import {
  Avatar,
  Box,
  Drawer,
  Link,
  Typography,
  Stack,
  MenuItem,
  Menu,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Snackbar,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import Iconify from '../../components/Iconify';
import Logo from '../../components/Logo';
import NavSection from '../../components/NavSection';
import Scrollbar from '../../components/Scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { authState, setAuth } from '../../../../Redux/authSlice';
import { useTheme } from '@mui/material/styles';
import jsPDF from 'jspdf';
import Tooltip from '@mui/material/Tooltip';
import { saveAs } from 'file-saver';


const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

const EXCLUDED_FIELDS = [
  'id',
  'legalMatterId',
  'legalMatter',
  'EstateId',
  'estateId',
  'EstateID',
  'IsDeleted',
  'isDeleted',
  'SequenceNo',
  'sequenceNo',
  'Documents',
  'documents',
  'Transaction',
  'transaction',
  'DateCreated',
  'dateCreated',
];
const EXCLUDED_FIELDS_IMMOVABLE = [
  'id',
  'legalMatterId',
  'legalMatter',
  'EstateId',
  'estateId',
  'EstateID',
  'IsDeleted',
  'isDeleted',
  'SequenceNo',
  'sequenceNo',
  'Documents',
  'documents',
  'Transaction',
  'transaction',
  'DateCreated',
  'dateCreated',
];

function filterFields(item) {
  const filtered = {};
  Object.entries(item).forEach(([key, value]) => {
    if (!EXCLUDED_FIELDS.includes(key)) {
      filtered[key] = value == null ? '' : value;  // replace null or undefined with empty string
    }
  });
  return filtered;
}

function getWeekNumber(date) {
  const firstDay = new Date(date.getFullYear(), 0, 1);
  const pastDays = (date - firstDay) / 86400000;
  return Math.ceil((pastDays + firstDay.getDay() + 1) / 7);
}


export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const isDesktop = window.innerWidth >= 1280;
  const dispatch = useDispatch();
  const auth = useSelector(authState);
  const [loggedinUserName, setLoggedinUserName] = useState('');
  const [loggedinUserLastName, setLoggedinUserLastName] = useState('');
  const [loggedinUserPhotoURL, setLoggedinUserPhotoURL] = useState('');
  const [navConfig, setNavConfig] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [openModal, setOpenModal] = useState('');
  const [reportData, setReportData] = useState(null);
  const [loadingReport, setLoadingReport] = useState(false);
  const [errorReport, setErrorReport] = useState('');
  const [legalMatterId, setLegalMatterId] = useState(null);
  const { id } = useParams();
  const { pathname } = useLocation();
  const theme = useTheme();
  const [editedImmovables, setEditedImmovables] = useState([]);
  const [matter, setMatter] = useState(null);
  const [estateId, setEstateId] = useState(null);
  const estateIdFromMatter = matter?.EstateID || estateId || '';
  const [selectedLanguage, setSelectedLanguage] = useState('English');
  const [user, setUser] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);
  const [estate, setEstate] = useState(null);
  const [legalMatter, setLegalMatter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  // REMOVED: const [modalOpen, setModalOpen] = useState(false);
  // REMOVED: const [modalType, setModalType] = useState(null);
  // REMOVED: const [modalItems, setModalItems] = useState([]);
  // REMOVED: const [loadingItems, setLoadingItems] = useState(false);
  const navigate = useNavigate();


  const [selectedWeek, setSelectedWeek] = useState(() => {
    const now = new Date();
    const year = now.getFullYear();
    const week = getWeekNumber(now);
    return `${year}-W${String(week).padStart(2, '0')}`;
  });

  const ReportDialog = ({
    openModal,
    handleCloseModal,
    reportData,
    loadingReport,
    errorReport,
    theme,
  }) => {
    const navigate = useNavigate();
  }

  const handleNavigateToItem = (item) => {
    if (!item?.id || !item?.type) return;

    if (item.type === 'matter') {
      navigate(`/matter/${item.id}`);
    } else if (item.type === 'estate') {
      navigate(`/matter/${item.id}`);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get('https://ipms.insollex.com/api/user', { withCredentials: true });
        setUser(res.data);
      } catch (err) {
        console.error('Error fetching user:', err);
      }
    };

    fetchUser();
  }, []);

  const checkIfNewMatter = (id) => {
    // UUID v4 pattern: 8-4-4-4-12 hex chars
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidV4Regex.test(id);
  };

  // Load matter/estate based on ID
  useEffect(() => {
    if (!id) {
      setLegalMatterId(null);
      setMatter(null);
      setEstate(null);
      setEstateId(null);
      return;
    }

    const isNew = checkIfNewMatter(id);
    setLegalMatterId(isNew ? id : null);

    const fetchContext = async () => {
      setLoading(true);
      setError(null);

      try {
        if (isNew) {
          const res = await fetch(`https://ipms.insollex.com/api/legal-matter/${id}`);
          if (!res.ok) throw new Error('Legal matter not found');
          const data = await res.json();
          setMatter(data);
          setEstateId(data?.EstateID || null);
          setEstate(null);
        } else {
          const res = await fetch(`https://ipms.insollex.com/api/old-database/estates/${id}`);
          if (!res.ok) throw new Error('Estate not found');
          const data = await res.json();
          setEstate(data);
          setEstateId(data?.ID || null);
          setMatter(null);
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContext();
  }, [id, pathname]);


  // Load matter details on id or pathname change
  useEffect(() => {
    if (!id) {
      setLegalMatterId(null);
      setMatter(null);
      setEstateId(null);
      return;
    }

    const isOld = isOldDatabase(id);
    setLegalMatterId(isOld ? null : id); // only set legalMatterId if new DB

    if (isOld) {
      // For old DB, treat id as estateId and fetch estate only
      axios.get(`https://ipms.insollex.com/api/old-database/estates/${id}`)
        .then(({ data }) => {
          setMatter(null); // no matter in old DB
          setEstateId(data?.ID || null);
        })
        .catch(() => {
          setEstateId(null);
        });
    } else {
      // New DB, fetch matter
      axios.get(`https://ipms.insollex.com/api/legal-matter/${id}`)
        .then(({ data }) => {
          setMatter(data);
          setEstateId(data?.EstateID || null);
        })
        .catch(() => {
          setMatter(null);
          setEstateId(null);
        });
    }
  }, [id, pathname]);


  useEffect(() => {
    if (id) {
      setLegalMatterId(id);
    } else {
      setLegalMatterId(null);
    }
  }, [id, pathname]);

  // REMOVED: handleOpenSelectionModal
  // REMOVED: handleSelectItem


  // Function to determine if the ID is from the old database (numeric) or new (UUID)
  const isOldDatabase = (id) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return !uuidRegex.test(String(id)); // True if numeric / old database
  };


  const handleGeneratePdf = async (formName, selection = '') => {
    // Only used for "Enquiry" (form4) after removing other advert forms
    if (formName !== 'form4') return; 

    if (!estate && !legalMatterId) {
      setSnackbarMessage('Estate or Legal Matter not found');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    const docxTemplateMap = {
      form4: ['Enquiry.docx', 'Enquiry 2.docx'],
    };

    const templateFiles = docxTemplateMap[formName];
    if (!templateFiles || templateFiles.length === 0) {
      setSnackbarMessage(`Template not found for form: ${formName}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    setLoadingForm(formName);

    try {
      const BASE_URL = 'https://ipms.insollex.com';

      // Normalize selection to a primitive (number/string) - kept for compatibility
      let selectionParam = '';
      if (selection) {
        if (typeof selection === 'object' && selection.id != null) {
          selectionParam = selection.id;
        } else {
          selectionParam = selection;
        }
      }

      for (const templateFileName of templateFiles) {
        let url;

        if (estate) {
          if (!estate.ID) {
            setSnackbarMessage('Estate ID is missing');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
          }

          url = `${BASE_URL}/api/pdf/estate/${estate.ID}?templateName=${encodeURIComponent(templateFileName)}&selection=${encodeURIComponent(selectionParam)}`;
        } else if (legalMatterId) {
          const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
          if (!uuidRegex.test(String(legalMatterId))) {
            setSnackbarMessage('Invalid Legal Matter ID. Expected UUID.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
          }

          url = `${BASE_URL}/api/pdf/legalMatter/${legalMatterId}?templateName=${encodeURIComponent(templateFileName)}&selection=${encodeURIComponent(selectionParam)}`;
        }

        try {
          const response = await axios.get(url, { responseType: 'blob' });
          const blob = new Blob([response.data], { type: 'application/pdf' });

          const cleanName = templateFileName.replace('.docx', '').replace(/\s+/g, '_');
          const fileName = estate
            ? `${formName}_${estate.ID}_${cleanName}_${selectionParam}.pdf`
            : `${formName}_${legalMatterId}_${cleanName}_${selectionParam}.pdf`;

          saveAs(blob, fileName);

          setSnackbarMessage(`PDF generated successfully: ${fileName}`);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        } catch (downloadError) {
          console.error(`[PDF] Error downloading template ${templateFileName}:`, downloadError);
          setSnackbarMessage(`Failed to download template ${templateFileName}: ${downloadError?.message || downloadError}`);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      }
    } catch (err) {
      console.error('[PDF] Unexpected error:', err);
      setSnackbarMessage(`Unexpected error generating ${formName.toUpperCase()}: ${err?.message || err}`);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoadingForm(null);
    }
  };


  // 🔹 Main function
  const handleCreateReport = async () => {
    setLoadingReport(true);
    setErrorReport('');
    setReportData(null);

    try {
      console.log("🔍 Fetching all matters and matter cards...");

      const [mattersRes, cardsRes] = await Promise.allSettled([
        axios.get('https://ipms.insollex.com/api/legal-matter'),
        axios.get('https://ipms.insollex.com/api/matter-card'),
      ]);

      // --- Process matters
      const matters = Array.isArray(mattersRes.value?.data?.matters)
        ? mattersRes.value.data.matters
        : Array.isArray(mattersRes.value?.data?.data)
          ? mattersRes.value.data.data
          : Array.isArray(mattersRes.value?.data)
            ? mattersRes.value.data
            : [];

      // --- Process matter cards (estates)
      const matterCards = Array.isArray(cardsRes.value?.data?.cards)
        ? cardsRes.value.data.cards
        : Array.isArray(cardsRes.value?.data?.data)
          ? cardsRes.value.data.data
          : Array.isArray(cardsRes.value?.data)
            ? cardsRes.value.data
            : [];

      console.log("Raw matters:", mattersRes.value?.data);
      console.log("Raw matterCards:", cardsRes.value?.data);
      console.log(`✅ Retrieved ${matters.length} matters`);
      console.log(`✅ Retrieved ${matterCards.length} matter cards`);

      let allResults = [];

      // Helper function for finding the name, prioritizing common keys
      const findName = (item) => {
        return item.matterName || item.Name || item.Name1 || item.estateName || item.Description || 'Unknown Matter';
      };


      // --- Handle matters
      for (const m of matters) {
        // **FIXED NAME RETRIEVAL**
        const name = findName(m); 
        const id = m.id || undefined;

        // Provisional Certificate
        allResults.push({
          id,
          type: 'matter',
          Name: name,
          Field: 'Provisional Certificate',
          Value: m.provisionalCertificate === "1" ? 'Issued' : 'Not Issued',
          reportTitle:
            m.provisionalCertificate === "1"
              ? `Provisional Certificate Issued for ${name}`
              : `❌ Provisional Certificate Missing for ${name}`,
        });
        
        // ... (rest of the matter logic is unchanged)

        // Bond Security
        allResults.push({
          id,
          type: 'matter',
          Name: name,
          Field: 'Provisional Certificate Application',
          Value: m.provisionalCertificateApplication === "1" ? 'Issued' : 'Not Issued',
          reportTitle:
            m.provisionalCertificateApplication === "1"
              ? `Bond Security Issued for ${name}`
              : `❌ Bond Security Missing for ${name}`,
        });

        // Appointments
        const appointmentsRes = await axios.get(`https://ipms.insollex.com/api/appointments`, {
          params: { legalMatterId: id },
        });
        const linkedAppointments = Array.isArray(appointmentsRes.data?.data)
          ? appointmentsRes.data.data
          : appointmentsRes.data || [];

        const firstMeeting = linkedAppointments.find(a => a.type === 'first');
        const secondMeeting = linkedAppointments.find(a => a.type === 'second');

        allResults.push({
          id,
          type: 'matter',
          Name: name,
          Field: 'First Meeting',
          Value: firstMeeting ? 'Found' : 'Missing',
          reportTitle: firstMeeting ? `First Meeting for ${name}` : `❌ First Meeting Missing for ${name}`,
        });

        allResults.push({
          id,
          type: 'matter',
          Name: name,
          Field: 'Second Meeting',
          Value: secondMeeting ? 'Found' : 'Missing',
          reportTitle: secondMeeting ? `Second Meeting for ${name}` : `❌ Second Meeting Missing for ${name}`,
        });

        // Court Orders
        const docRes = await axios.get(`https://ipms.insollex.com/api/documents`, {
          params: { legalMatterId: id, folder: 'Final Court Order' },
        });
        const documentsData = Array.isArray(docRes.data) ? docRes.data : [];
        allResults.push({
          id,
          type: 'matter',
          Name: name,
          Field: 'Court Order',
          Value: documentsData.length > 0 ? 'Found' : 'Missing',
          reportTitle:
            documentsData.length > 0
              ? `Final Court Order found for ${name}`
              : `❌ Outstanding Final Court Order for ${name}`,
        });
      }

      // --- Handle estates (matter cards)
      for (const e of matterCards) {
        // **FIXED NAME RETRIEVAL**
        const name = findName(e);
        const id = e.EstateID || e.id || e.MatterCardID || undefined;

        allResults.push({
          id,
          type: 'estate',
          Name: name,
          Field: 'Provisional Certificate',
          Value: e.provisionalCertificate === "1" ? 'Issued' : 'Not Issued',
          reportTitle:
            e.provisionalCertificate === "1"
              ? `Provisional Certificate Issued for ${name}`
              : `❌ Provisional Certificate Missing for ${name}`,
        });

        allResults.push({
          id,
          type: 'estate',
          Name: name,
          Field: 'Provisional Certificate Application',
          Value: e.provisionalCertificateApplication === "1" ? 'Issued' : 'Not Issued',
          reportTitle:
            e.provisionalCertificateApplication === "1"
              ? `Bond Security Issued for ${name}`
              : `❌ Bond Security Missing for ${name}`,
        });

        // Court Orders
        const docRes = await axios.get(`https://ipms.insollex.com/api/old-database/documents`, {
          params: { estateId: id, folder: 'Final Court Order' },
        });
        const documentsData = Array.isArray(docRes.data) ? docRes.data : [];
        allResults.push({
          id,
          type: 'estate',
          Name: name,
          Field: 'Court Order',
          Value: documentsData.length > 0 ? 'Found' : 'Missing',
          reportTitle:
            documentsData.length > 0
              ? `Final Court Order found for ${name}`
              : `❌ Outstanding Final Court Order for ${name}`,
        });
      }

      // --- Filter results for selected report type
      let filtered = [];
      switch (openModal) {
        case 'cashbook':
          filtered = allResults.filter(r => r.Field === 'Provisional Certificate');
          break;
        case 'bond-security':
          filtered = allResults.filter(r => r.Field === 'Provisional Certificate Application');
          break;
        case 'weekly':
          filtered = allResults.filter(r => r.Field === 'First Meeting');
          break;
        case 'accounts-due':
          filtered = allResults.filter(r => r.Field === 'Second Meeting');
          break;
        case 'court-order':
          filtered = allResults.filter(r => r.Field === 'Court Order');
          break;
        default:
          setErrorReport('Unknown report type.');
          return;
      }

      // **Filter to only show outstanding/missing items**
      const outstandingResults = filtered.filter(r => 
        r.Value === 'Not Issued' || r.Value === 'Missing'
      );

      console.log(`📊 Filtered report data for "${openModal}" (Outstanding Only):`, outstandingResults);
      setReportData(outstandingResults);
    } catch (err) {
      console.error('❌ Error generating report:', err);
      setErrorReport(err.message || 'Failed to generate report.');
    } finally {
      setLoadingReport(false);
    }
  };


  const handleDownloadAdvert = () => {
    if (!reportData || !reportData.length) return;

    const advert = reportData[0];
    const doc = new jsPDF();

    const content = `
Legal Form: ${advert.form}
Language: ${advert.language}
Date: ${advert.publishDate}

--------------------------------------

${advert.content}
    `.trim();

    // Add the text to PDF
    doc.setFontSize(12);
    const lines = doc.splitTextToSize(content, 180); // split into multiple lines if needed
    doc.text(lines, 15, 20);

    // Save the PDF
    const filename = `${advert.form.replace(' ', '-')}-${advert.language}.pdf`;
    doc.save(filename);
  };

  const handleSaveImmovable = async (immovable) => {
    try {
      await axios.put(`https://ipms.insollex.com/api/immoveables/${immovable.id}`, {
        ...immovable,
        isSold: immovable.soldStatus === 'Sold',
      });
      alert('Saved successfully');
    } catch (err) {
      console.error('Save error:', err);
      alert('Failed to save');
    }
  };


  const fetchDataForWeek = (week) => {
    console.log("Refreshed for week:", week);
    // Trigger any state updates, filtering, or re-rendering here
  };


  const handleOpenMenu = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  const handleHelpManualClick = () => {
    window.open('https://ipms.insollex.com/manual/IPMS_Test_document.pdf', '_blank');
    handleClose();
  };

  const handleOpenModal = (type) => {
    setOpenModal(type);
    handleClose();
  };

  const handleCloseModal = () => {
    setOpenModal('');
    setReportData(null);
    setErrorReport('');
  };

  useEffect(() => {
    if (isOpenSidebar) onCloseSidebar();
    (async () => {
      try {
        const { data } = await axios.get('https://ipms.insollex.com/api/user');
        setLoggedinUserName(data.firstName);
        setLoggedinUserLastName(data.lastName);
        if (data.avatar) {
          const avatarPath = data.avatar.startsWith('/static/') ? data.avatar : `/static/${data.avatar.replace(/^\/+/g, '')}`;
          setLoggedinUserPhotoURL(`https://ipms.insollex.com${avatarPath}`);
        }
        dispatch(setAuth(true));
        const { role } = data;
        const filteredNav = generateNavConfig(role);
        setNavConfig(filteredNav);
      } catch (e) {
        dispatch(setAuth(false));
        setLoggedinUserName('Not logged in');
        setLoggedinUserLastName('');
        setLoggedinUserPhotoURL('');
        console.error('Error fetching user data:', e.message);
      }
    })();
  }, [pathname]);

  useEffect(() => {
    if (openModal && ['cashbook', 'weekly', 'bond-security', 'accounts-due', 'court-order'].includes(openModal)) {
      handleCreateReport();
    }
  }, [openModal]);

  // Try to find the name from the reportData (if available)
  const activeName = (() => {
    if (!reportData || !Array.isArray(reportData)) return '';
    const first = reportData[0];
    if (!first) return '';
    return first.matterName || first.estateName || '';
  })();

  const REPORT_TITLES = {
    'cashbook': 'Outstanding Prov. Certificate',
    'weekly': 'Outstanding First Meetings',
    'bond-security': 'Outstanding Final Certificate App.',
    'accounts-due': 'Outstanding 2nd Meetings',
    'court-order': 'Outstanding Final Court Order',
    // REMOVED: 'meeting-advert': 'Meeting Advertisement',
    // REMOVED: 'enquiry': 'Enquiry Advertisement',
    // REMOVED: 'confirmation-account': 'Account Advertisement',
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };


  const renderContent = (
    <>
      <Scrollbar
        sx={{
          height: 1,
          '& .simplebar-content': {
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
          <Logo />
        </Box>

        <Box sx={{ mb: 5, mx: 2.5 }}>
          <Link underline="none" component={RouterLink} to="/profile">
            <AccountStyle>
              <Avatar src={loggedinUserPhotoURL} alt="User Photo" />
              <Box sx={{ ml: 2 }}>
                <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                  {loggedinUserName}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {loggedinUserLastName}
                </Typography>
              </Box>
            </AccountStyle>
          </Link>
        </Box>

        <NavSection navConfig={navConfig} />

        <Box sx={{ mx: 2.5, mt: 3 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Quick Actions
          </Typography>

          <Stack spacing={1} alignItems="flex-start">
            {[
              { label: 'Reports', menu: 'reports' },
              // REMOVED: { label: 'Advertisement', menu: 'advert' },
              { label: 'Help', menu: 'help' },
            ].map(({ label, menu }) => (
              <Button
                key={menu}
                size="small"
                color="inherit"
                variant="text"
                endIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
                onClick={(e) => handleOpenMenu(e, menu)}
                sx={{
                  justifyContent: 'flex-start',
                  color: 'text.primary',
                  fontWeight: 500,
                  textTransform: 'capitalize',
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                  px: 1.5,
                  minWidth: 160,
                }}
              >
                {label}
              </Button>
            ))}
          </Stack>
        </Box>


        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {activeMenu === 'reports' && (
            <>
              <MenuItem onClick={() => handleOpenModal('cashbook')} disabled={user?.role === 'guest' || user?.isInvited}>
                Outstanding Prov. Certificate
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal('bond-security')} disabled={user?.role === 'guest' || user?.isInvited}>
                Outstanding final Certificate App.
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal('weekly')} disabled={user?.role === 'guest' || user?.isInvited}>
                Outstanding first Meetings
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal('accounts-due')} disabled={user?.role === 'guest' || user?.isInvited}>
                Outstanding 2nd Meetings
              </MenuItem>
              <MenuItem onClick={() => handleOpenModal('court-order')} disabled={user?.role === 'guest' || user?.isInvited}>
                Outstanding Final Court Order
              </MenuItem>
            </>
          )}

          {/* REMOVED: activeMenu === 'advert' block and associated Dialog */}

          {activeMenu === 'help' && (
            <MenuItem onClick={handleHelpManualClick}>Open System Manual</MenuItem>
          )}
        </Menu>

        <Box sx={{ flexGrow: 1 }} />
      </Scrollbar>

      <Dialog
    open={!!openModal}
    onClose={handleCloseModal}
    fullWidth
    maxWidth="lg"
    sx={{
        '& .MuiDialog-paper': {
            minHeight: '80vh',
            maxHeight: '90vh',
            width: '90vw',
            maxWidth: '90vw',
        },
    }}
>
    <DialogTitle
        sx={{
            fontWeight: 'bold',
            fontSize: '1.5rem',
            borderBottom: `1px solid ${theme.palette.divider}`,
            pb: 2,
            mb: 2,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
        }}
    >
        {REPORT_TITLES[openModal] || 'Report'}
    </DialogTitle>

    <DialogContent
        sx={{
            px: 4,
            py: 2,
            maxHeight: '75vh',
            overflowY: 'auto',
            overflowX: 'auto',
            '& table': {
                width: 'max-content',
                minWidth: '100%',
                borderCollapse: 'collapse',
                tableLayout: 'auto',
            },
            '& th, & td': {
                padding: '10px 12px',
                borderBottom: `1px solid ${theme.palette.divider}`,
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                textAlign: 'left',
                maxWidth: 300,
            },
            '& th': {
                backgroundColor:
                    theme.palette.mode === 'dark'
                        ? theme.palette.grey[800]
                        : theme.palette.grey[200],
                color: theme.palette.text.primary,
                fontWeight: '600',
                borderBottom: `2px solid ${theme.palette.divider}`,
                position: 'sticky',
                top: 0,
                zIndex: 1,
            },
            '& td': {
                color: theme.palette.text.primary,
            },
            '& tr:hover': {
                backgroundColor: theme.palette.action.hover,
            },
        }}
    >
        {loadingReport ? (
            <LinearProgress />
        ) : errorReport ? (
            <Typography color="error">{errorReport}</Typography>
        ) : reportData && reportData.length > 0 ? (
            <Box className="table-scroll">
                <Box component="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            // 1. Deduplicate by ID
                            [...new Set(reportData.map(item => item.id))]
                                // 2. Map unique IDs back to the original item object
                                .map(id => reportData.find(item => item.id === id))
                                // 3. Render the unique list of names
                                .map((item, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            <Typography
                                                sx={{
                                                    cursor: item.id && item.type ? 'pointer' : 'default',
                                                    color: item.id && item.type ? 'primary.main' : 'text.primary',
                                                    textDecoration: item.id && item.type ? 'underline' : 'none',
                                                }}
                                                // FIX: Call handleNavigateToItem AND handleCloseModal on click
                                                onClick={() => {
                                                    handleNavigateToItem(item);
                                                    handleCloseModal();
                                                }}
                                            >
                                                {item.Name || '-'}
                                            </Typography>
                                        </td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </Box>
            </Box>
        ) : (
            <Typography>No data available.</Typography>
        )}
    </DialogContent>

    <DialogActions>
        <Button onClick={handleCloseModal}>Close</Button>
    </DialogActions>
</Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000} // 4 seconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </>
  );


  return (
    <RootStyle>
      {!isDesktop ? (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}

function generateNavConfig(role) {
  const baseNavConfig = [
    { title: 'dashboard', path: '/coreapp', icon: getIcon('eva:pie-chart-2-fill') },
    { title: 'users', path: '/users', icon: getIcon('eva:people-fill'), roles: ['admin'] },
    { title: 'estate', path: '/matter', icon: getIcon('eva:shopping-bag-fill') },
    { 
            title: 'mail list', 
            path: '/mail-list', 
            icon: getIcon('eva:email-outline'), // Using an envelope icon
            roles: ['admin'] 
          },
    { title: 'blog', path: '/blog', icon: getIcon('eva:file-text-fill') },
  ];
  return baseNavConfig.filter((item) => !item.roles || item.roles.includes(role));
}

function getIcon(name) {
  return <Iconify icon={name} width={22} height={22} />;
}
